import { render, staticRenderFns } from "./SupplierLeft.vue?vue&type=template&id=184f6534"
import script from "./SupplierLeft.vue?vue&type=script&lang=js"
export * from "./SupplierLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports